import {generateCallback} from '../util/appCallback';
export default function invoking({action = '', data = {}, option = {}, version = '1.0.0'} = {}) {
    // 仅用于单元测试
    if (option.__unittest_hit_invoking__) {
        option.__unittest_hit_invoking__(action, data, option);
    }

    // version 遗留，非必需
    const v = version || '1.0.0';
    if (action) {
        try {
            window.MMAPP && window.MMAPP.invocation(action, v, generateCallback(option, option.fixCallback, option.isDestroyCallback), JSON.stringify(data));
        } catch (e) {
            console.error(`window.MMAPP.invocation 错误：${e}`);
        }
    } else {
        console.error('缺少action!');
    }
}
